import React, {StrictMode}  from "react";
import ReactDOM from "react-dom";
import {createRoot} from 'react-dom/client';

import "./index.css";
import App from "./App/App.js";
import reportWebVitals from "./reportWebVitals.js";
import { HashRouter as Router } from "react-router-dom";
import { createTheme, CssBaseline, ThemeProvider } from "@mui/material";
import { red } from "@mui/material/colors";

const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

const theme = createTheme({
  palette: {
    mode: "dark"
  }
});


const heroTheme = createTheme({
  palette: {
    mode: "dark",
    primary: red
  },
  components: {
    MuiTypography: {
      styleOverrides: {
        root: {
          fontFamily: "Open Sans"
        }
      }
    },
    MuiCssBaseline: {
      styleOverrides: `
      .make-uppercase {
          text-transform: uppercase
        },
      .header-font {
        font-family: "Open Sans",
        text-transform: uppercase
      }  
        
      `
    }
  }
});


root.render(
  <StrictMode>
    <Router>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <App />
      </ThemeProvider>
    </Router>
  </StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

